import { defineMessages } from 'react-intl';

export default defineMessages({
    userAdded: {
        id: "ri.admin.ManageRI_Users.user successfully added.",
        defaultMessage: "user successfully added."
    },
    userUpdated: {
        id: "ri.admin.ManageRI_Users.user successfully modified.",
        defaultMessage: "user successfully modified."
    },
    userDeleted: {
        id: "ri.admin.ManageRI_Users.user successfully removed.",
        defaultMessage: "user successfully removed."
    },
    error: {
        id: "ri.admin.ManageRI_Users.User retrieve error.",
        defaultMessage: "User retrieve error."
    },
    error1: {
        id: "ri.admin.ManageRI_Users.User modification error.",
        defaultMessage: "User modification error."
    },
});
